import type { IVoteOptimizationStrategy } from "./vote-optimization-strategy"
import { BeastVoteOptimizationStrategy } from "./strategies/beast-vote-optimization-strategy"
import { DegenVoteOptimizationStrategy } from "./strategies/degen-vote-optimization-strategy"
import { SafeVoteOptimizationStrategy } from "./strategies/safe-vote-optimization-strategy"

/**
 * Strategy type constants - use these instead of magic strings
 */
export const STRATEGY_TYPE = {
  SAFE: "safe",
  DEGEN: "degen",
  BEAST: "beast",
} as const

export type VoteOptimizationStrategyType = (typeof STRATEGY_TYPE)[keyof typeof STRATEGY_TYPE]

/**
 * Strategy icon constants - use these for icon selection
 */
export const STRATEGY_ICON = {
  SHIELD: "shield",
  FLAME: "flame",
  SWORD: "sword",
  TOKEN: "token",
} as const

export type StrategyIconType = (typeof STRATEGY_ICON)[keyof typeof STRATEGY_ICON]

/**
 * Factory for creating vote optimization strategies
 */
export class VoteOptimizationStrategyFactory {
  /**
   * Create a strategy instance based on the strategy type
   */
  static create(strategyType: VoteOptimizationStrategyType): IVoteOptimizationStrategy {
    switch (strategyType) {
      case STRATEGY_TYPE.SAFE:
        return new SafeVoteOptimizationStrategy()
      case STRATEGY_TYPE.DEGEN:
        return new DegenVoteOptimizationStrategy()
      case STRATEGY_TYPE.BEAST:
        return new BeastVoteOptimizationStrategy()
      default:
        // Exhaustiveness check - this should never happen with proper typing
        throw new Error(`Unknown strategy type: ${strategyType}`)
    }
  }

  /**
   * Get all available strategy types
   */
  static getAvailableStrategies(): Array<VoteOptimizationStrategyType> {
    return [STRATEGY_TYPE.SAFE, STRATEGY_TYPE.DEGEN, STRATEGY_TYPE.BEAST]
  }
}
